import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState } from '../../../store/app.states';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '../../../services/dialog.service';
import { Observable } from 'rxjs';
import { PatientService } from '../../../services/patient.service';
import { Patient } from '../../../model/user/Patient';

@Component({
  selector: 'app-questionnaires-show',
  templateUrl: './questionnaires-show.component.html',
  styleUrls: ['./questionnaires-show.component.css']
})
export class QuestionnairesShowComponent implements OnInit {

  getAuthState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  title: string;
  destination: string;
  type: string;
  patient: Patient;
  patientSSN: string;

  // CONFIG
  toShow = null;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private patientService: PatientService,
    private dialogService: DialogService) {
    this.getAuthState = this.store.select(selectAuthState);
    this.route.params.subscribe(params => {
      this.patientSSN = params.ssn;
      this.type = params.type;
      this.title = this.type.toUpperCase();
    });
  }

  ngOnInit(): void {
    this.getAuthState.subscribe(state => {
      if (state.isAuthenticated) {
        this.user = JSON.parse(localStorage.getItem('user'));
      }
    });
    if (this.toShow === null || this.toShow === undefined) {
      this.toShow = JSON.parse(localStorage.getItem(this.type.toLowerCase()));
      if (this.toShow !== null) {
        this.toShow.sort((r1, r2) => this.comparing(r1, r2));
      }
    }
    this.destination = 'questionnaires-completed';
    this.setupSelf();
  }

  setupSelf() {
    this.patient = new Patient(
      this.user.email,
      this.user.name,
      this.user.surname,
      this.user.ssn,
      this.user.birthDate,
      this.user.birthPlace,
      this.user.phoneNumber,
      this.user.checkClinicalData,
      //JSON.parse(localStorage.getItem('bodyStat')),
      this.user.pathology,
      JSON.parse(localStorage.getItem('doctor')),
      JSON.parse(localStorage.getItem('questionnaires'))
    );
  }

  comparing(r1, r2) {
    const d1 = new Date(r1.date);
    const d2 = new Date(r2.date);
    return d1 < d2 ? 1 : (d1 > d2 ? -1 : 0);
  }

  goTo(r) {
    switch (this.type) {
      /*case 'clinical-sccai':
        this.dialogService.openClinicalSCCAIDialog(r, this.user.role, this.patient);
        break;*/
      case 'eortc-qlq':
        this.dialogService.openEORTCDialog(r, this.user.role, this.patient);
        break;
      case 'eq5d5l':
        this.dialogService.openEQ5D5LDialog(r, this.user.role, this.patient);
        break;
      case 'hads':
        this.dialogService.openHADSDialog(r, this.user.role, this.patient);
        break;
      case 'hbi':
        this.dialogService.openHBIDialog(r, this.user.role, this.patient);
        break;
      case 'ibd-disk':
        this.dialogService.openIBDDiskDialog(r, this.user.role, this.patient);
        break;
      case 'ipaq-sf':
        this.dialogService.openIPAQSFDialog(r, this.user.role, this.patient);
        break;
      case 'miah-cd':
        this.dialogService.openMIAHCDDialog(r, this.user.role, this.patient);
        break;
      case 'miah-uc':
        this.dialogService.openMIAHUCDialog(r, this.user.role, this.patient);
        break;
      case 'mmas8':
        this.dialogService.openMMAS8Dialog(r, this.user.role, this.patient);
        break;
      case 'patient-sccai':
        this.dialogService.openPatientSCCAIDialog(r, this.user.role, this.patient);
        break;
      case 'phq9':
        this.dialogService.openPHQ9Dialog(r, this.user.role, this.patient);
        break;
      case 'prism':
        this.dialogService.openPRISMDialog(r, this.user.role, this.patient);
        break;
      case 'psqi':
        this.dialogService.openPSQIDialog(r, this.user.role, this.patient);
        break;
      case 'sibdq':
        this.dialogService.openSIBDQDialog(r, this.user.role, this.patient);
        break;
      case 'ibdq':
        this.dialogService.openIBDQDialog(r, this.user.role, this.patient);
        break;
      case 'lars':
        this.dialogService.openLARSDialog(r, this.user.role, this.patient);
        break;
      case 'tsqm':
        this.dialogService.openTSQMDialog(r, this.user.role, this.patient);
        break;
      case 'wpai':
        this.dialogService.openWPAIDialog(r, this.user.role, this.patient);
        break;
      default:
        break;
    }
  }

}
